<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">

    <template v-if="data.shipping">
      <span class="cf-icon cf-icon--block cf-icon--large cf-icon--brand-primary far fa-truck" />

      <h1 class="cf-title cf-title--1">
        Shipping Not Available
      </h1>

      <p class="cf-subtitle cf-subtitle--2">
        Sorry, it looks like we can't ship to your address at this time. You could try pickup instead.
      </p>
    </template>

    <template v-else>
      <span class="cf-icon cf-icon--block cf-icon--large cf-icon--brand-primary far fa-car" />

      <h1 class="cf-title cf-title--1">
        Delivery Not Available
      </h1>

      <p class="cf-subtitle cf-subtitle--2">
        Sorry, it looks like we can't deliver in your area

        <template v-if="data.timestamp">
          <b>
            {{ $momentCalendar(data.timestamp, null, selectedLocation.timeZone) }}
          </b>.
        </template>

        <template v-else>
          at this time.
        </template>

        <template v-if="data.canTryChangingTime">
          You could try a different delivery time or switch to pickup instead.
        </template>

        <template v-else>
          You could try pickup instead.
        </template>
      </p>
    </template>

    <button
      type="button"
      class="cf-button cf-button--lg cf-button--primary cf-button--fill"
      @click="$closeModal('deliveryNotAvailable')"
    >
      {{ data.canTryChangingTime ? 'Change Time' : 'Cancel' }}
    </button>

    <button
      type="button"
      class="cf-button cf-button--lg cf-button--secondary cf-button--fill"
      @click="switchToPickUp"
    >
      Pickup
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'DeliveryNotAvailable',

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation'])
    },

    methods: {
      switchToPickUp() {
        this.$closeAllModals();

        this.$openModal('editOrderDetails', { fulfillmentType: 'pick-up' });
      }
    }
  };
</script>

